import { useRef, useState, useEffect } from "react";
import styles from './cssModules/index.module.css';
import { useNavigate } from "react-router-dom";
import { auth } from "./firebase";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import Spinner from 'react-bootstrap/Spinner';

// ENV variable import to get URL
const apiURL = process.env.REACT_APP_SELLER;

export default function SellerLogin({ loginStatus, username }) {
    const [state, setState] = useState({
        otp: 0, // OTP box Display none (0)/ inline (1)
        resend: 0 // Change of Request (0)/ Resend (1)/ Validate (2)
    });
    const phoneNumber = useRef(null);
    const input_user = useRef(null);
    const input_otp = useRef(null);
    const navigate = useNavigate();
    // const [otp, setOtp] = useState(0);

    const [showIncorrectOTPMsg, setshowIncorrectOTPMsg] = useState(false);

    const [resendDisable, setResendDisable] = useState(false);

    const [renendGap, setResendGap] = useState(0);

    const [showResend, setResend] = useState(false);

    let resendInterval;

    const [validateDisabled, setvalidateDisabled] = useState(false);

    const [confirmation, setConfirmation] = useState(null);

    // Spinner Show enabling
    const [showSpinner, setShowSpinner] = useState(false);


    useEffect(() => {
        const fetchData = async () => {
            try {
                let response = await fetch(`${apiURL}/api/loginCheck`, {
                    method: 'GET',
                    headers: { 'Content-type': 'Application/json' },
                    credentials: "include"
                })

                if (response.status === 500) {
                    throw new Error('Login api error');
                } else {
                    if (response.status === 200) {
                        navigate('/');
                    }
                }
            } catch (error) {
                navigate('/error');
                console.log(error.message);
            }
        }

        fetchData();
    }, [navigate]);

    let inputCheck = function (e) { // On change event
        if (e.target.value.length === 10) {
            setState((values) => {
                return { ...values, otp: 1 } // Make OTP = 1 means, Open OTP request button
            });
        }
        else {
            setState((values) => {
                return { ...values, otp: 0 } // Make OTP = 0 means, close OTP request button
            });
        }
    }


    const setupRecaptcha = () => {
        // Check if container exists in DOM
        const containerExists = document.getElementById('recaptcha-container');
        if (!containerExists) {
            console.error('recaptcha-container div is missing from the DOM!');
            return;
        }

        // Only create verifier if not already present
        if (!window.recaptchaVerifier) {
            try {
                window.recaptchaVerifier = new RecaptchaVerifier(auth,
                    'recaptcha-container',
                    {
                        'size': 'invisible',
                        'callback': () => {
                            console.log("reCAPTCHA verified");
                        },
                        'expired-callback': () => {
                            window.location.reload();
                        }

                    }
                );

                window.recaptchaVerifier.render().then(widgetId => {
                    window.recaptchaWidgetId = widgetId;
                });
            } catch (error) {
                console.error("Failed to initialize reCAPTCHA:", error);
            }
        } else {
            console.log("reCAPTCHA already initialized.");
        }
    };

    async function requestOtp(e) {
        try {
            e.preventDefault();
            setShowSpinner(true);
            // Firebase OTP
            if (window.recaptchaVerifier) {
                window.recaptchaVerifier.clear();
                window.recaptchaVerifier = null;
            }

            setupRecaptcha();

            const appVerifier = window.recaptchaVerifier;
            let phone = `+91${input_user.current.value}`;

            try {
                setvalidateDisabled(true);
                const confirmationResult = await signInWithPhoneNumber(auth, phone, appVerifier);
                setConfirmation(confirmationResult);
                alert('OTP sent');
                setShowSpinner(false);
                setvalidateDisabled(false);
            } catch (error) {
                setvalidateDisabled(false);
                console.error("SMS not sent", error);
                console.log('Error from line no 110');
            }

            input_otp.current.style.display = 'inline' // Display OTP input box
            setResendGap(30);
            setResendDisable(true);
            setState((values) => {
                return ({ ...values, resend: 2 }) // request 1 means, display validate msg
            });
            resendInterval = setInterval(() => {
                setResendGap(prev => prev - 1);
            }, 1000);
            setTimeout(() => {
                setResendDisable(false);
                clearInterval(resendInterval)
            }, 30000);
            input_user.current.disabled = true;


        } catch (error) {
            console.log(error.message);
            navigate('/error');
        }
    }

    async function handleOTP(e) {
        try {
            e.preventDefault();
            const fetchData = await fetch(`${apiURL}/api/signUp`, {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    "key": 'phone'
                },
                body: JSON.stringify({ phoneNumber: input_user.current.value }),
                credentials: "include"
            });

            if (fetchData.status === 500) {
                throw new Error('Error while handeling OTP');
            } else {
                const res = await fetchData.json();
                if (res) {
                    if (state.resend === 0) { // When we have OTP button in request mode, execute the below code
                        setResend(false);
                        requestOtp(e);
                        setResend(true);
                    } else if (state.resend === 2) { // When OTP button shows "validate" when OTP is 4 digit
                        try {
                            setvalidateDisabled(true);
                            let otp = input_otp.current.value;
                            await confirmation.confirm(otp);
                            setvalidateDisabled(false);

                            const response = await fetch(`${apiURL}/authenticate`, {
                                method: 'POST',
                                headers: {
                                    'Content-type': 'Application/json'
                                },
                                body: JSON.stringify({
                                    phoneNumber: Number(input_user.current.value)
                                }),
                                credentials: "include"
                            })
                            if (response.status === 200) {
                                const authRes = await response.json();
                                await loginStatus();
                                username(authRes.fname);
                                localStorage.setItem('token', authRes.token);
                                localStorage.setItem('ctoken', authRes.csrfToken);
                                navigate('/dashboard');
                            } else {
                                alert('Error occured! Please try after sometime');
                            }
                        } catch (error) {
                            setvalidateDisabled(false);
                            console.log(error.message);
                            setshowIncorrectOTPMsg(true);
                        }
                    }
                } else {
                    alert('Phone number is not registered!');
                    navigate('/signUp');
                }
            }
        } catch (error) {
            console.log(error.message);
            navigate('/error');
        }
    }

    useEffect(() => {
        input_otp.current.style.display = 'none';
    }, []);

    function navigateSignUp() {
        navigate('/signUp');
    }

    return (
        <>
            <div className={`${styles.mainDiv}`}>
                <div className={`${styles.rightDiv}`}>
                    <span className={`${styles.loginSignupHeading}`}>EXISTING SELLER LOG IN</span>
                    <form className={`${styles.form}`}>
                        <div className={`${styles.formDiv}`}>
                            <label className={`${styles.EnterphonNo}`}>ENTER PHONE NUMBER</label>
                            <div className={`${styles.OTPdiv}`}>
                                <input type="text" ref={input_user} onChange={inputCheck}
                                    className={`${styles.baseInput}`} />

                                <input id='otp' type="text" ref={input_otp} maxLength={6}
                                    onChange={() => setshowIncorrectOTPMsg(false)}
                                    className={`${styles.userInput}`} placeholder='Enter OTP here' />

                                <div className={`${styles.placeHolderDiv}`}></div>

                                {/* <div style={{ height: '1px', backgroundColor: 'black' }}></div> */}

                                {/* <input id='try' type="number" ref={input_otp} onChange={otpInput} /> */}
                                <input type="button" className={`${styles.resendBtn}`} ref={phoneNumber}
                                    style={state.otp === 1 ? { display: 'block' } : { display: 'none' }}
                                    value={state.resend === 0 ? 'Request OTP' : state.resend === 1 ? 'Resend OTP' : 'VALIDATE'}
                                    onClick={e => handleOTP(e)} disabled = {validateDisabled}/>
                                <div style={showResend ? { visibility: 'visible' } : { visibility: 'hidden' }}>
                                    <p id='incorrectOTP' className={`${styles.incorrectOTPMsg}`}
                                        style={showIncorrectOTPMsg ? { visibility: 'visible' } : { visibility: 'hidden' }}>Incorrect OTP</p>
                                    <span style={{ fontSize: '12px' }}>Didn't receive OTP? resend in {renendGap} seconds</span>
                                    <button disabled={resendDisable} onClick={e => requestOtp(e)}
                                        className={`${styles.resendBtnLogin}`}>RESEND</button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div style={showSpinner ? { display: 'block', alignSelf: 'center' } : { display: 'none' }}>
                        <Spinner animation="grow" style={{ width: "30px", height: "30px" }} />
                    </div>
                    <div className={`${styles.notHave}`} style={{ marginTop: '50px' }}>
                        <span className={`${styles.dontAccont}`}>DONT'T HAVE AN ACCOUNT</span>
                        <button onClick={navigateSignUp} className={`${styles.signRoute}`}>
                            Click here
                        </button>
                    </div>
                </div>
                <div id="recaptcha-container"></div>
            </div>
        </>
    )
};